// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"749cfb36","543":"f0b069fc","698":"a7b84c04","766":"3f86d823","837":"0f13c56c","920":"534938a5","976":"219dd4c5"}[chunkId] + ".chunk.css";
};